module.exports = __webpack_public_path__ + "img/40.a351faf6.svg";